import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription,
  AlertDialogFooter, AlertDialogCancel,
} from "@/components/ui/alert-dialog";

// confirm = {title, body, label, danger, run: async fn} or null
export default function ConfirmDialog({ confirm, onClose }) {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    if (busy) return;
    setBusy(true);
    try { await confirm.run(); onClose(); } finally { setBusy(false); }
  };
  return (
    <AlertDialog open={!!confirm} onOpenChange={(v) => !v && !busy && onClose()}>
      <AlertDialogContent className="bg-white" data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{confirm?.title}</AlertDialogTitle>
          {confirm?.body && <AlertDialogDescription>{confirm.body}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy} data-testid="confirm-cancel">Cancel</AlertDialogCancel>
          <Button onClick={go} disabled={busy} data-testid="confirm-ok"
            className={confirm?.danger ? "bg-rose-600 hover:bg-rose-700" : "bg-indigo-600 hover:bg-indigo-700"}>
            {busy && <Loader2 className="w-4 h-4 mr-1 animate-spin" />}{confirm?.label || "Confirm"}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
